module.exports = __webpack_public_path__ + "static/media/nidologo.c6aae41a.png";